import type {
  CreateInfringementDto,
  InfringementsControllerFindAllData,
  InfringementsControllerGetUserActionNeededCountData,
  InfringementUserActionNeededCountDto,
  UpdateInfringementDto,
} from '@carvia/ros-client-types';
import type { Infringement } from '@carvia/ros-client-types';
import type { PaginatedResponse } from '@/entities/pagination/paginated-response';
import { Service } from './http-service';

class InfringementsService extends Service<
  Infringement,
  CreateInfringementDto,
  UpdateInfringementDto
> {
  constructor() {
    super('/infringements');
  }

  async getAllWithQuery(params: InfringementsControllerFindAllData['query']) {
    const res = await this.httpClient.get<PaginatedResponse<Infringement>>(`${this.endpoint}`, {
      params,
    });
    return res.data;
  }

  async getUserActionNeededCount(
    params?: InfringementsControllerGetUserActionNeededCountData['query'],
  ) {
    const res = await this.httpClient.get<InfringementUserActionNeededCountDto>(
      `${this.endpoint}/user-action-needed-count`,
      { params },
    );
    return res.data;
  }

  async execute(id: string) {
    const res = await this.httpClient.post<Infringement>(`${this.endpoint}/${id}/execute`);
    return res.data;
  }

  async retryFindBooking(id: string) {
    const res = await this.httpClient.post<Infringement>(
      `${this.endpoint}/${id}/retry/find-booking`,
    );
    return res.data;
  }

  async retryChargeFee(id: string) {
    const res = await this.httpClient.post<Infringement>(`${this.endpoint}/${id}/retry/charge-fee`);
    return res.data;
  }

  async retrySendAuthorityEmail(id: string) {
    const res = await this.httpClient.post<Infringement>(
      `${this.endpoint}/${id}/retry/send-authority-email`,
    );
    return res.data;
  }
}

export const infringementsService = new InfringementsService();
